import request from '@/utils/request'

// 查询信标日志列表
export function listBeaconLog(query) {
  return request({
    url: '/system/beacon-log/list',
    method: 'get',
    params: query,
  })
}

// 查询信标日志分页
export function pageBeaconLog(query) {
  return request({
    url: '/system/beacon-log/page',
    method: 'get',
    params: query,
  })
}

// 查询信标日志详细
export function getBeaconLog(data) {
  return request({
    url: '/system/beacon-log/detail',
    method: 'get',
    params: data,
  })
}

// 新增信标日志
export function addBeaconLog(data) {
  return request({
    url: '/system/beacon-log/add',
    method: 'post',
    data: data,
  })
}

// 修改信标日志
export function updateBeaconLog(data) {
  return request({
    url: '/system/beacon-log/edit',
    method: 'post',
    data: data,
  })
}

// 删除信标日志
export function delBeaconLog(data) {
  return request({
    url: '/system/beacon-log/delete',
    method: 'post',
    data: data,
  })
}
